import { ceilToNextThousand } from '../../../../../../utilities/helper/unitConvertor/roundLastThreeToZero';

export const discountedAdvertisementPrice = (
  adPrice?: number | null,
  discountAmount?: number | null, // discount percentage
) => {
  const safeAdPrice = adPrice ?? 0;

  const discounted =
    !discountAmount || discountAmount <= 0
      ? safeAdPrice
      : safeAdPrice - (safeAdPrice * discountAmount) / 100;

  return ceilToNextThousand(discounted);
};

export const reverseDiscountPrice = (
  discountedPrice: number,
  discountPercent: number,
) => {
  if (!discountPercent) return discountedPrice;

  return ceilToNextThousand(discountedPrice / (1 - discountPercent / 100));
};
